import React from 'react';

import reducer from './duck';
import FloatingNavigation from './components/floating_navigation';

const { addReducers } = window.reduxState;

addReducers({
  floatingNavigation: reducer,
});

// Expose the helpers for calls from backbone
// eslint-disable-next-line import/no-webpack-loader-syntax
require('expose-loader?FloatingNavigationHelpers!./helpers');

const App = () => (
  <FloatingNavigation />
);

export default App;
